import React from "react";
import Loader from "react-loader-spinner";

const Loading = () => {
  return (
    <div style={{ position: "absolute", right: "50%", top: "50%" }}>
      <Loader
        type="TailSpin"
        color="#8b1538"
        height={100}
        width={100}
        timeout={3000} //3 secs
      />
    </div>
  );
};

export default Loading;
